// removed by extract-text-webpack-plugin
module.exports = {"block":"_2zJP4BGTl63jLYCdeD_nF_","check":"_1_q-PYYkYtRSZu-1IrDmey","active":"_3IYz7jdaBZGeUSCp5X0oeP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/Checkbox.module.scss
// module id = 740
// module chunks = 0